import React, { Fragment, useEffect, useState } from "react";
import { deleteCookie } from "../utils/setCookie";
import deleteSession from "../services/deleteSession";
import { useSearchParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/system";
import config from "../config/config";
import { googleLogout } from "@react-oauth/google";

const LogOut = ({ children }) => {
  const [searchParams] = useSearchParams();
  const [existsLogout, setExistsLogOut] = useState(true);

  useEffect(() => {
    const logout = searchParams.get("logout");
    console.log("Ingresa en useeffect Logout");
    if (logout === "1") {
      console.log("Ingresa en Logout 1");

      deleteSession()
        .then(() => {
          deleteCookie();
          googleLogout();
        })
        .catch((error) => console.log(error))
        .finally(() => {
          // Redirige a una URL sin el parámetro logout
          window.location.replace(config.URL_LOGOUT_ME);
        });
      console.log("Termina borrado de sesion con sdk");

      return;
    }
    console.log("No ingreso el logout = 1");
    setExistsLogOut(false);
  }, [searchParams]);

  return (
    <Fragment>
      {existsLogout ? (
        <Box
          sx={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={"4rem"} sx={{ color: "#263057" }} />
        </Box>
      ) : (
        children
      )}
    </Fragment>
  );
};

export default LogOut;
